// extracted by mini-css-extract-plugin
export default {"container":"TbbItemList_container__eCzBf"};